import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import '../../style/tab.css';
import '../../iconfont/iconfont.css';

function Tab(props) {
    // 功能菜单
    const tabList = [
        {
            id: 'C-Y-F-Z-G-K',
            icon: 'icon-chanye',
            name: '产业发展概况'
        },
        {
            id: 'J-T-Q-K',
            icon: 'icon-daolu',
            name: '交通情况'
        },
        {
            id: 'M-L-X-C',
            icon: 'icon-meilixiangcun',
            name: '美丽乡村'
        },
        {
            id: 'Z-D-Q-Y-F-B',
            icon: 'icon-qiyefenbu',
            name: '重点企业分布'
        },
        {
            id: 'S-S-W-Z-D-G-C',
            icon: 'icon-guojiazhongdiangongchengdanweiguanli',
            name: '十四五重点工程'
        },
        {
            id: 'Z-S-Z-T',
            icon: 'icon-zhaoshangzaiti',
            name: '招商载体'
        }
    ]
    // 选中菜单
    const [cMenu, setCMenu] = useState('C-Y-F-Z-G-K');
    // 默认展示菜单个数
    const [slidesPerView, setSlidesPerView] = useState(6);

    useEffect(() => {
        // 手机端设置菜单展示个数
        if (window.innerWidth > 768) {
            setSlidesPerView(6);
        } else {
            setSlidesPerView(3);
        }
    }, []);

    return (
        <div className="tab">
            <Swiper
                className="tab-box"
                slidesPerView={slidesPerView}
            >
                {
                    tabList.map((item) => (
                        <SwiperSlide
                            className={`tab-box__item ${item.id === cMenu ? 'active' : ''}`}
                            key={item.id}
                            onClick={() => {
                                setCMenu(item.id)
                                props.onChangeTab(item.id)
                            }}
                        >
                            <span className="tab-box__item--icon">
                                <span className={`icon iconfont ${item.icon}`}></span>
                            </span>
                            <span className="tab-box__item--name">{item.name}</span>
                        </SwiperSlide>
                    ))
                }
            </Swiper>
        </div>
    );
}

export default Tab;